import React from 'react';
import { maskSnorkel } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Snorkeling spot',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'snorkeling-spot',
  icon: {
    baseShape: maskSnorkel,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'snorkelingSpotMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Snorkeling spot',
      itemTitleFunction: (item) => (item && item.title) || 'Snorkeling spot',
    },
    creationOptions: {
      menuText: 'Snorkeling spot',
      newTitle: 'Snorkeling spot',
      titlePlaceholder: 'Name of snorkeling spot',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a snorkeling spot.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Snorkeling spot',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
